import { render, staticRenderFns } from "./PackageActivationSwitch.vue?vue&type=template&id=55809f21&scoped=true"
import script from "./PackageActivationSwitch.vue?vue&type=script&lang=js"
export * from "./PackageActivationSwitch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55809f21",
  null
  
)

export default component.exports